import type { KnowledgeBaseDocumentNumericStatsDTO } from '../../types/lac';
import { formatBytes } from '../../utils/formatUtils';

export function hasNumericStats(
  stats: KnowledgeBaseDocumentNumericStatsDTO | null | undefined,
): stats is KnowledgeBaseDocumentNumericStatsDTO {
  return (
    stats != null &&
    (stats.min != null || stats.avg != null || stats.max != null)
  );
}

export type FileSizeStatPart = {
  key: 'min' | 'avg' | 'max';
  label: string;
  value: string;
};

export function getFileSizeStatParts(
  stats: KnowledgeBaseDocumentNumericStatsDTO | null | undefined,
  locale: string,
  labels: { min: string; avg: string; max: string },
): FileSizeStatPart[] {
  if (!hasNumericStats(stats)) {
    return [];
  }

  const parts: FileSizeStatPart[] = [];

  if (stats.min != null) {
    parts.push({
      key: 'min',
      label: labels.min,
      value: formatBytes(stats.min, locale),
    });
  }
  if (stats.avg != null) {
    parts.push({
      key: 'avg',
      label: labels.avg,
      value: formatBytes(Math.round(stats.avg), locale),
    });
  }
  if (stats.max != null) {
    parts.push({
      key: 'max',
      label: labels.max,
      value: formatBytes(stats.max, locale),
    });
  }

  return parts;
}
